// extracted by mini-css-extract-plugin
module.exports = {"header":"Home_header__6gPPp","subtitle":"Home_subtitle__3pAVv","homeButton":"Home_homeButton__wl6_U","discordLogo":"Home_discordLogo__ii3GX"};